import { toast } from 'react-toastify';
import { fetchLibraryProducts } from '../../app/api/mockApi';
import {
  asyncActionError,
  asyncActionFinish,
  asyncActionStart,
} from '../../app/async/asyncReducer';
import { delay } from '../../app/common/util/util';

const INCREMENT_COUNTER = 'INCREMENT_COUNTER';
const DECREMENT_COUNTER = 'DECREMENT_COUNTER';
const FETCH_LIBRARY_PRODUCTS = 'FETCH_LIBRARY_PRODUCTS';

export function fetchProducts(products) {
  return async function (dispatch) {
    dispatch(asyncActionStart());
    try {
      await delay(1000);
      const products = await fetchLibraryProducts();
      dispatch({ type: FETCH_LIBRARY_PRODUCTS, payload: products });
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError(error));
    }
  };
}

export function increment(amount) {
  return async function (dispatch) {
    dispatch(asyncActionStart());
    try {
      await delay(1000);
      dispatch({ type: INCREMENT_COUNTER, payload: amount });
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError(error));
    }
  };
}
export function decrement(amount) {
  return async function (dispatch) {
    dispatch(asyncActionStart());
    try {
      await delay(1000);
      dispatch({ type: DECREMENT_COUNTER, payload: amount });
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError(error));
      toast.error(error);
    }
  };
}

const initialState = {
  data: 42,
  products: [],
};

export default function testReducer(state = initialState, { type, payload }) {
  switch (type) {
    case INCREMENT_COUNTER:
      return {
        ...state,
        data: state.data + payload,
      };
    case DECREMENT_COUNTER:
      return {
        ...state,
        data: state.data - payload,
      };
    case FETCH_LIBRARY_PRODUCTS:
      return {
        ...state,
        products: payload,
      };
    default:
      return state;
  }
}
